module.exports = {
    "my.topic": "My Topic",
    "reply.topic": "Replied Topic",
    "his.topic": "Their topics",
    "pub.topic": "My topics",
    "my.collect.topic": "My Collected Topic",
    "his.collect.topic": "Their Collected Topic"
}


// WEBPACK FOOTER //
// ./src/pages/myCollect/i18n/locale.en.js